import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function StatsGridTemplate({ draft, accent }) {
  const stats = [
    { label: "Roles", value: draft.experience.length },
    { label: "Projects", value: draft.projects.length },
    { label: "Certifications", value: draft.certifications.length },
    { label: "Skills", value: draft.skills.length },
  ];
  return (
    <div className="bg-white text-slate-900 rounded-xl p-8 shadow-2xl text-[13px] leading-snug" data-testid="resume-live-preview">
      <h1 className="text-2xl font-bold" style={{ color: accent }}>{draft.full_name || "Your Name"}</h1>
      <p className="text-slate-500 text-xs mt-0.5">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join(" | ")}</p>
      {draft.target_role && <p className="text-slate-600 text-xs mt-0.5 font-semibold">{draft.target_role}</p>}

      <div className="grid grid-cols-4 gap-2.5 mt-4">
        {stats.map((s) => (
          <div key={s.label} className="rounded-lg text-center py-3" style={{ backgroundColor: `${accent}12` }}>
            <p className="text-xl font-bold" style={{ color: accent }}>{s.value}</p>
            <p className="text-[10px] font-semibold uppercase tracking-wide text-slate-500 mt-0.5">{s.label}</p>
          </div>
        ))}
      </div>

      {draft.summary && (
        <div className="mt-4">
          <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Summary</h2>
          <p className="text-slate-700 mt-1">{draft.summary}</p>
        </div>
      )}
      {draft.skills.length > 0 && (
        <div className="mt-4">
          <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Skills</h2>
          <div className="flex flex-wrap gap-1.5 mt-1.5">
            {draft.skills.map((sk) => <span key={sk} className="text-[11px] font-medium px-2 py-0.5 rounded-full border" style={{ borderColor: accent, color: accent }}>{sk}</span>)}
          </div>
        </div>
      )}
      {draft.experience.length > 0 && (
        <div className="mt-4">
          <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Experience</h2>
          {draft.experience.map((e, i) => (
            <div key={i} className="mt-2">
              <p className="font-semibold text-slate-800">{e.title} — {e.company} <span className="text-slate-400 font-normal italic">({dateRange(e.start_date, e.end_date, e.current)})</span></p>
              <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
            </div>
          ))}
        </div>
      )}
      {draft.education.length > 0 && (
        <div className="mt-4">
          <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Education</h2>
          {draft.education.map((ed, i) => <p key={i} className="text-slate-700 mt-1"><span className="font-semibold text-slate-800">{ed.degree} {ed.field}</span> — {ed.school}</p>)}
        </div>
      )}
      <ExtraResumeSections draft={draft} accent={accent} />
    </div>
  );
}
